import { atom } from 'jotai'
import type { Client, User } from '~/models'

export const aClient = atom<Client>({} as Client)
export const aUser = atom<User | null>(null)
